import { OUTCOME_MEASUREMENT_TYPES } from 'src/constants/prompt-level-template';

export const isNumericOutcome = (type) => {
  return [
    OUTCOME_MEASUREMENT_TYPES.WEIGHTED,
    OUTCOME_MEASUREMENT_TYPES.RATING_SCALE,
  ].includes(type);
};

export const isRatingScale = (type) => {
  return type === OUTCOME_MEASUREMENT_TYPES.RATING_SCALE;
};

/**
 * Formats the raw rating score value to a consistent string representation.
 * @param {number|null|undefined} score
 * @returns {string}
 */
export const formatRatingScore = (score) => {
  return score === null || score === undefined ? '-' : `${Number(score).toFixed(1)}`;
};
